import type { NamedOption } from "./types";
import { inputClass, labelClass, sectionCard } from "./constants";

type BasicInfoSectionProps = {
  brands: NamedOption[];
  brandId: number | null;
  setBrandId: (id: number | null) => void;
  showBrandInput: boolean;
  setShowBrandInput: (show: boolean) => void;
  newBrandName: string;
  setNewBrandName: (name: string) => void;
  handleAddNewBrand: () => void;
  name: string;
  setName: (name: string) => void;
  description: string;
  setDescription: (description: string) => void;
};

export const BasicInfoSection = ({
  brands,
  brandId,
  setBrandId,
  showBrandInput,
  setShowBrandInput,
  newBrandName,
  setNewBrandName,
  handleAddNewBrand,
  name,
  setName,
  description,
  setDescription,
}: BasicInfoSectionProps) => (
  <section className={sectionCard}>
    <h2 className="text-xl font-semibold text-[#5c2f2f] mb-4">
      Basic Information
    </h2>

    <div className="grid grid-cols-1 gap-5">
      <div>
        <label className={labelClass}>Brand</label>
        <select
          value={brandId ?? ""}
          onChange={(e) => {
            if (e.target.value === "new") {
              setShowBrandInput(true);
              setBrandId(null);
            } else {
              setBrandId(Number(e.target.value));
              setShowBrandInput(false);
            }
          }}
          className={inputClass}
        >
          <option value="">Select brand</option>
          <option value="new">+ Add New Brand</option>
          {brands.map((brand) => (
            <option key={brand.id} value={brand.id}>
              {brand.name}
            </option>
          ))}
        </select>

        {showBrandInput && (
          <div className="mt-3 flex gap-2">
            <input
              type="text"
              placeholder="New brand name"
              value={newBrandName}
              onChange={(e) => setNewBrandName(e.target.value)}
              className={inputClass}
            />
            <button
              type="button"
              onClick={handleAddNewBrand}
              className="px-4 py-3 rounded-xl bg-[#5c2f2f] text-white hover:bg-[#7a4444]"
            >
              Save
            </button>
          </div>
        )}
      </div>

      <div>
        <label className={labelClass}>Product Name</label>
        <input
          type="text"
          placeholder="Enter product name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={inputClass}
        />
      </div>

      <div>
        <label className={labelClass}>Description</label>
        <textarea
          placeholder="Write a short product description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className={`${inputClass} min-h-[120px]`}
        />
      </div>
    </div>
  </section>
);
